module.exports = __webpack_public_path__ + "static/media/logo.16f0914e.png";